export const PrivacyPolicy = () => {
  document.title = "My Routine: Build Habits | Privacy Policy";

  return (
    <div className="min-h-screen bg-base-200 text-base-content px-4 py-10">
      <div className="max-w-3xl mx-auto bg-base-100 shadow-xl rounded-xl p-6 md:p-10">
        <h2 className="text-3xl font-bold text-center mb-8">Privacy Policy</h2>

        <Section title="Introduction">
          Welcome to <strong>My Routine</strong>! This Privacy Policy applies to both our mobile application and website. It explains how we collect, use, and protect your personal information. Your privacy is very important to us.
        </Section>

        <Section title="Data Collection and Usage">
          <p>We collect and process certain personal and usage data to provide you with a better experience:</p>
          <ul className="list-disc list-inside mt-2">
            <li>
              <strong>Personal Information:</strong> Name, email, and password (encrypted) are collected when you register an account.
            </li>
            <li>
              <strong>App Data:</strong> Routines, journals, schedules, and preferences are stored in our backend database so you can access them across devices and securely back them up.
            </li>
            <li>
              <strong>Usage:</strong> We use this data to provide account access, sync features, reminders, and app improvements. We do not sell your information to third parties.
            </li>
          </ul>
        </Section>

        <Section title="Storage and Security">
          <p>Your information is stored securely on our servers. Passwords are hashed and never stored in plain text. We implement industry-standard safeguards to prevent unauthorized access, disclosure, or misuse of your data.</p>
        </Section>

        <Section title="Ads and Third-Party Services">
          <p>
            This app uses <strong>Google AdMob</strong> to serve ads. Google may collect certain data such as IP address, device ID, OS version, and ad interactions to deliver relevant ads.
          </p>
          <p className="mt-2">
            To opt out of personalized ads on Android:
            <br />
            <code className="bg-base-300 px-2 py-1 rounded">Settings &gt; Privacy &gt; Ads</code>
          </p>
        </Section>

        <Section title="Permissions Used">
          <ul className="list-disc list-inside mt-2">
            <li>
              <strong>SYSTEM_ALERT_WINDOW:</strong> For overlays.
            </li>
            <li>
              <strong>FOREGROUND_SERVICE:</strong> To run background notifications.
            </li>
            <li>
              <strong>POST_NOTIFICATIONS:</strong> For sending alerts.
            </li>
            <li>
              <strong>RECEIVE_BOOT_COMPLETED:</strong> Resumes your routine after restarting.
            </li>
          </ul>
        </Section>

        <Section title="Your Rights">
          <ul className="list-disc list-inside mt-2">
            <li>You can access, update, or delete your personal data within the app.</li>
            <li>You may request deletion of your account and all related data by contacting us.</li>
            <li>You may also request an export of your personal data by contacting us.</li>
          </ul>
        </Section>

        <Section title="Children’s Privacy">
          <p>Our services are not directed to children under 13. We do not knowingly collect personal information from children. If we become aware that a child under 13 has provided us with data, we will delete it immediately.</p>
        </Section>

        <Section title="Security">
          <p>While we take reasonable steps to protect your information, no method of storage or transmission is 100% secure. Please keep your login credentials safe and secure your device.</p>
        </Section>

        <Section title="Changes to This Privacy Policy">
          <p>We may update this Privacy Policy from time to time. Any changes will be posted here with an updated effective date.</p>
        </Section>

        <Section title="Contact Us">
          <p>
            Questions, requests, or concerns? Reach out to us:
            <br />
            <span className="font-semibold">Email:</span>{" "}
            <a href="mailto:uxpress01@gmail.com" className="text-primary hover:underline">
              uxpress01@gmail.com
            </a>
          </p>
        </Section>

        <Section title="Google Play and App Store Compliance">
          <p>This app complies with Google Play and App Store policies regarding data, permissions, and advertising. If you believe we are in violation, please contact us directly.</p>
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h4 className="text-lg font-semibold mb-2 border-b border-base-300 pb-1">{title}</h4>
    <div className="text-sm leading-relaxed">{children}</div>
  </div>
);

export default PrivacyPolicy;
